import React from 'react';
import { TextField } from '@mui/material';

const Input = (props) => {
  return <TextField {...props} />;
};

export default Input;
